import { useQuery } from 'react-query'
import { AxiosInstance } from 'axios'

import { useSvcCrunchesContext } from '@dc-shared-web/providers'

import { AssignmentUser } from '@dc-shared-web/hooks/api/assignment/types'

export const fetchAssignmentUsers = async (
  apiClient: AxiosInstance,
  crunchUuid: string
): Promise<AssignmentUser[]> => {
  const response = await apiClient.get<AssignmentUser[]>(
    `/api/crunches/${crunchUuid}/assignable-users`
  )
  return response.data
}

export const useGetAssignmentUsers = (
  crunchUuid: string,
  enabled: boolean = true
) => {
  const apiClient = useSvcCrunchesContext()

  return useQuery<AssignmentUser[], Error>({
    queryKey: ['assignment-users', crunchUuid],
    queryFn: () => fetchAssignmentUsers(apiClient, crunchUuid),
    enabled,
  })
}
